module.exports = __webpack_public_path__ + "img/diagram-2.fe06f01b.svg";